module.exports = __webpack_public_path__ + "static/media/S37.b8559690.png";